module.exports = __webpack_public_path__ + "static/media/AntonioLorena.3102e356.jpeg";